<template>
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span
          class="crumb"
          @click="
            $router.push({ path: '/' });
            resetSetItem('isActive', 0);
          "
          >首页</span
        >
        <span>></span>
        <span style="color:#0091ff">兑换中心</span>
      </div>

      <div class="channel-exchange-container">
        <!-- 兑换区域 -->

        <div class="exchange-container">
          <h1 class="exchange-title">兑换中心</h1>
          <!-- 兑换表单 -->
          <div class="exchange-form">
            <exange-input label="请输入兑换码" v-model="form.cdKey" />
            <exange-input label="请输入手机号" v-model="form.phoneNumber" />
            <exange-input
              type="verifiCode"
              label="请输入验证码"
              apiName="yicai"
              :phone="form.phoneNumber"
              v-model="form.confirmationtoken"
            />
          </div>

          <!-- 提交btn -->
          <el-button
            type="primary"
            class="exhange-btn"
            @click="onSubmit"
            :loading="loading"
            round
            >提交</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExangeInput from "./components/Input.vue";
import { doFreeTrial, docoupon } from "@/api/channel.js";
import md5 from "md5";
import { getTdkList} from "@/api/tdk";

export default {
  data() {

    let cdKey = null;
    let phoneNumber = null;

    return {
      form: {
        // 兑换码
        cdKey,
        // 手机号
        phoneNumber,
        // 验证码
        confirmationtoken: null,
        // 签名
        key: "ceC8HJY693Z0GMTp",
        cf_style: 0
      },
      loading: false
    };
  },
  methods: {
    async onSubmit() {
      // 表单校验空值
      if (!this.checkFormEmpty()) return;
      // 表单校验
      if (!this.validateForm()) return;
      this.loading = true;
      const {
        cdKey,
        phoneNumber,
        confirmationtoken,
        cf_style,
        key
      } = this.form;
      let payload = {
        phoneNumber,
        confirmationtoken,
        source: "yc_magazine_ums"
      };
      let requestApi = null;
      let check = null;

      /**
       * 兑换: 长度大于等于20位，且第5位为1，为兑换券/码
       *
       * 体验:
       * 体验券/码：大于等于20位且第5位为2是体验码/券
       * 体验口令，长度小于20位
       */

      let docouponType = cdKey.length >= 20 && cdKey[4] == 1;
      if (docouponType) {
        payload.cdKey = cdKey;
        requestApi = docoupon;
        check = md5(`${cdKey}${phoneNumber}${confirmationtoken}${key}`);
        payload.check = check;
      } else {
        requestApi = doFreeTrial;
        if (cdKey.length >= 20 && cdKey[4] == 2) {
          payload.cdKey = cdKey;
          payload.cf_style = 0;
          check = md5(`${0}${phoneNumber}${confirmationtoken}${key}`);
          payload.check = check;
        } else {
          payload.cf_style = 1;
          check = md5(`${1}${phoneNumber}${confirmationtoken}${key}`);
          payload.check = check;
          payload.cf_command = cdKey;
        }
      }
      try {
        const res = await requestApi(payload);
        this.$message({
          type: "success",
          message: "兑换成功"
        });
      } catch (error) {
        console.log(error);
        this.showError(error.message || error);
      }
      this.loading = false;
    },
    // 表单校验是否为空
    checkFormEmpty() {
      const { cdKey, phoneNumber, confirmationtoken } = this.form;
      if (!cdKey) {
        this.showError("请输入兑换码");
        return false;
      }
      if (!phoneNumber) {
        this.showError("请输入手机号");
        return false;
      }
      if (!confirmationtoken) {
        this.showError("请输入验证码");
        return false;
      }
      return true;
    },
    // 校验表单
    validateForm() {
      const { cdKey, phoneNumber, confirmationtoken } = this.form;
      let phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      if (!phoneReg.test(phoneNumber)) {
        this.showError("请输入正确的手机号");
        return;
      }

      return true;
    },
    showError(msg) {
      this.$message({
        type: "error",
        message: msg
      });
    }
  },
  components: {
    ExangeInput
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
  }
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
}
.channel-exchange-container {
  width: 387px;
  margin: 0 auto;
  padding: 34px 46px 46px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  .exchange-title {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 31px;
    line-height: 43px;
    color: #323232;
    text-align: center;
    margin-bottom: 21px;
  }

  .logo-container {
    width: 100%;
    height: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .logo {
      width: 1.12rem;
      height: 1.12rem;
      margin-bottom: 0.16rem;
    }

    h1 {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
    }
  }

  .exchange-container {
    flex: 1 0 auto;
    background: #ffffff;
    border-radius: 12px 12px 0px 0px;
    padding: 0.64rem 0.3rem;
    box-sizing: border-box;
    position: relative;

    .exchange-tips {
      font-size: 12px;
      line-height: 16px;
      color: #afafaf;
      p {
        margin-bottom: 0.2rem;
      }
    }

    .exhange-btn {
      width: 100%;
      height: 40px;
      border-radius: 60px;
      box-sizing: border-box;
      text-align: center;
      color: #fff;
      font-size: 16px;
      background: #0095fc;
      margin-top: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/channel/Exchange.vue